import React, { FC } from 'react';
import { ReactComponent as Print } from '../../../assets/ExportButtons/Print.svg';

export const PrintIcon: FC = () => <Print />;
